/**
 * Benefit Cards section – Swiper init for mobile card carousel.
 * Loads Swiper when missing; inits all [data-benefit-cards-swiper] instances.
 * Mobile: 1.125 slides visible. Desktop: grid override, 4 cards.
 */
(function() {
  function initBenefitCardsSwiper(container) {
    if (typeof window.Swiper === 'undefined') return;
    const section = container.closest('.el-benefit-cards-section');
    if (!section) return;
    const slider = section.querySelector('.el-benefit-cards__slider');
    const pagination = section.querySelector('.el-benefit-cards__pagination');
    if (!slider || !pagination || slider.swiper) return;
    const benefitCardsSwiper = new window.Swiper(slider, {
      loop: true,
      speed: 300,
      breakpoints: { 0: { slidesPerView: 1.125, spaceBetween: 16 }, 981: { slidesPerView: 4, spaceBetween: 24 } },
      pagination: { el: pagination, clickable: true },
      keyboard: { enabled: true, onlyInViewport: true }
    });
  }

  function runInits() {
    document.querySelectorAll('[data-benefit-cards-swiper]').forEach((container) => {
      initBenefitCardsSwiper(container);
    });
  }

  if (typeof window.Swiper !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runInits);
    else runInits();
    return;
  }
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css';
  document.head.appendChild(link);
  const s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js';
  s.onload = function() {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runInits);
    else runInits();
  };
  document.head.appendChild(s);
})();
